export default __webpack_public_path__ + "static/media/image1.c0fc9e0a.jpg";